module.exports = __webpack_public_path__ + "static/media/replyicon.fb92f7cf.svg";


//////////////////
// WEBPACK FOOTER
// /src/globals/images/replyicon.svg
// module id = 1999
// module chunks = 0